import React, { useState } from 'react';
import { Navigate } from "react-router-dom";
import { prettyPrintJson, FormatOptions } from 'pretty-print-json';
import "@dndViews/floating_feature/pretty-print-json.css";
import {
  ArrowBack
} from "@mui/icons-material";
import { Tooltip, Fab } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  CreatureFeature,
  ModelBase, 
} from "@models";

import API from "@dndUtilities/system_api";

import ButtonBox from "@components/input/buttons/ButtonBox";

import CenteredMenu from "@components/input/menus/CenteredMenu";
import FloatingFeatureBox from '@dndComponents/FloatingFeatureBox';
import FloatingFeatureInput from '@dndComponents/feature/FloatingFeatureInput';

const prettyPrintJsonOptions: FormatOptions = { 
  indent: 4, 
};

const api = API.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function CreatureFeatureEdit({ obj: param_obj }: Props) {
  const [processing, setProcessing] = useState(false);
  const [view, setView] = useState("Edit");
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<CreatureFeature>(param_obj instanceof CreatureFeature ? param_obj : new CreatureFeature());
  const [merge_floating_feature, setMergeCreatureFeature] = useState<CreatureFeature | null>(null);
  
  const merge = () => {
    if (merge_floating_feature) {
      const new_obj = obj;
      new_obj.merged_ids = [
        ...new_obj.merged_ids,
        merge_floating_feature._id,
        ...merge_floating_feature.merged_ids
      ];
      setObj(new_obj);
      setProcessing(true);
      api.upsertObject(new_obj.data_type, new_obj).then(res => {
        api.deleteObject(new_obj.data_type, merge_floating_feature).then(res2 => {
          setMergeCreatureFeature(null);
          setProcessing(false);
        });
      });
    }
  }

  const renderMerge = () => {
    return (
      <>
        <Grid size={12}>
          <FloatingFeatureBox
            name="Merge Feature"
            feature_type={ obj.feature_type }
            limit={100}
            floating_feature_id={ obj._id }
            exclude_ff
            onFloatingFeatureSelected={(changed) => {
              if (changed instanceof CreatureFeature) {
                setMergeCreatureFeature(changed);
              }
            }}
          />
        </Grid>
        { merge_floating_feature &&
          <>
            <Grid size={6}>This one</Grid>
            <Grid size={6}>Merging</Grid>
            <Grid size={6}>
              <section className="pretty-print">
                <output className="json-container" 
                  dangerouslySetInnerHTML={{ 
                    __html: prettyPrintJson.toHtml(
                      obj.toDBObj(), 
                      prettyPrintJsonOptions) 
                  }}>
                </output>
              </section>
            </Grid>
            <Grid size={6}>
              <section className="pretty-print">
                <output className="json-container" 
                  dangerouslySetInnerHTML={{ 
                    __html: prettyPrintJson.toHtml(
                      merge_floating_feature.toDBObj(), 
                      prettyPrintJsonOptions) 
                  }}>
                </output>
              </section>
            </Grid>
          </>
        }
        <Grid size={12}>
          <ButtonBox 
            name="Merge"
            disabled={ !merge_floating_feature || merge_floating_feature._id === obj._id || processing }
            onClick={merge}
          />
        </Grid>
      </>
    );
  }

  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else { 
    console.log(obj);
    const formHeight = window.innerHeight - 64;
    return (
      <div
        style={{ 
          height: `${formHeight}px`,
        }}>
        <Grid container spacing={0} direction="row">
          <Grid size={4}>
            <Tooltip title={`Back to Features`}>
              <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                onClick={ () => {
                  setNavigateTo(`/floating_feature`);
                }}>
                <ArrowBack/>
              </Fab>
            </Tooltip> 
            <span className="header">
              { obj._id === "" ? "Create Feature" : `Edit ${obj.name}` }
            </span>
          </Grid>
          <Grid size={4}>
            { api.user && api.user.admin && 
              <span><CenteredMenu options={["Edit","Merge"]} selected={view} onSelect={setView} /></span>
            }
          </Grid>
          <Grid size={4}></Grid>
          <Grid size={12}
            container spacing={0} direction="row">
            { view === "Merge" && obj._id !== "" && !processing ? renderMerge() 
            :
              <Grid size={12}>
                <FloatingFeatureInput 
                  floating_feature={obj}
                  height={formHeight - 40}
                  onDelete={() => {
                    setNavigateTo(`/floating_feature`);
                  }}
                  onAdd2={setObj}
                />
              </Grid>
            }
          </Grid>
        </Grid>
      </div>
    ); 
  }
}